module.exports = __webpack_public_path__ + "img/img4.decda64b.png";